/*
 * 网站配置相关
 * author: kirkzheng
 * time: 2016-06-17
 */
import tsaPath from './tsaPath.js';

export const IS_PRODUCTION = process.env.DEPLOY_ENV === 'production';

// 网站路径相关
export const SITE = {
  parentDomain: 'qq.com', // 顶级域名
  domain: document.domain, // app域名
  hermesUrl: `${location.origin}/hermes/index`, // 旧服务商域名
  path: tsaPath.join(), // app路径
  indexUrl: tsaPath.join('index'), // app首页
  apiUrl: tsaPath.join('api.php'), // app接口路径
  smbUrl: '/agp/', // 服务商融合后新的接口地址
  agsUrl: '/ags/', // 服务商销售融合后新的接口地址
  policyUrl: '/policy/', // 身份验证新的网关接口地址
  ecApiUrl: '/ec/api.php', // ec投放端接口路径
  mpDomain: 'https://a.weixin.qq.com/', // 微信广告服务商地址
  mpTSAUrl: 'https://a.weixin.qq.com/tsa/index.html', // 微信服务商嵌入地址
  serverPhone: '400-900-5050', // 客服电话
  portalUrl: '//e.qq.com/index.shtml', // 官网首页
  ssoUrl: 'https://sso.e.qq.com/login/portal',
  atlasUrl: '//ad.qq.com/atlas/', // 投放端url
  aresUrl: '//e.qq.com/ares/', // 合约 投放端url
  adpUrl: `${location.origin}/adp/advertiser/`,
  cpsUrl: `${location.origin}/contentad/`,
  enterpriseAPI: '//midas.gtimg.cn/enterprise/js/enterpriseAPI_v1.0.1.js', //
  html2pdf: 'https://public.gdtimg.com/qzone/biz/gdt/lib/html2pdf-0.9.2/html2pdf.js', // html2pdf
  skipAuthPath: [/task-advertiser/, /creative\/preview-detail/],
  huxuanUrl: IS_PRODUCTION ? 'https://huxuan.qq.com/' : 'https://test-huxuan.qq.com/',
};

export default { SITE };
